import { yupResolver } from "@hookform/resolvers/yup/dist/yup";
import { useForm } from "react-hook-form";
//@ts-ignore
import { FormLayout } from "@careinfo/layout";
import PaymentMethodForm from "./PaymentMethodForm";
import { paymentMethodValidationForm } from "../../utils/validationSchemas";

const CreatePaymentMethod = (props: any) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    setError,
  } = useForm<any>({
    resolver: yupResolver(paymentMethodValidationForm),
  });
  const { handleCreate, isLoading } = props;
  return (
    <FormLayout
      handleSubmit={handleSubmit}
      handleFormSubmit={handleCreate}
      setError={setError}
      buttonLabel={"Create"}
      isLoading={isLoading}
    >
      <PaymentMethodForm
        errors={errors}
        register={register}
      />
    </FormLayout>
  );
};

export default CreatePaymentMethod;